const RTF = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

export function formatRelativeTime(ms: number): string {
  const diffSeconds = Math.round((ms - Date.now()) / 1000);
  const abs = Math.abs(diffSeconds);
  if (abs < 60) return RTF.format(diffSeconds, 'second');
  if (abs < 3600) return RTF.format(Math.round(diffSeconds / 60), 'minute');
  if (abs < 86400) return RTF.format(Math.round(diffSeconds / 3600), 'hour');
  return RTF.format(Math.round(diffSeconds / 86400), 'day');
}
